/* eslint-disable react/jsx-props-no-spreading */
import Spoiler from "./Spoiler";

const Element = ({ attributes, children, element, key }) => {
  if (element.spoiler) {
    return (
      <Spoiler key={key} {...attributes}>
        {children}
      </Spoiler>
    );
  }
  switch (element.type) {
    case "block-quote":
      return (
        <blockquote key={key} {...attributes}>
          {children}
        </blockquote>
      );
    case "bulleted-list":
      return (
        <ul key={key} {...attributes}>
          {children}
        </ul>
      );
    case "heading-two":
      return (
        <h2 key={key} {...attributes}>
          {children}
        </h2>
      );
    case "list-item":
      return (
        <li key={key} {...attributes}>
          {children}
        </li>
      );
    case "numbered-list":
      return (
        <ol key={key} {...attributes}>
          {children}
        </ol>
      );
    case "div":
      return (
        <div key={key} {...attributes}>
          {children}
        </div>
      );
    case "br":
      return <br key={key} {...attributes} />;
    default:
      return (
        <p key={key} {...attributes}>
          {children}
        </p>
      );
  }
};

export default Element;
